import "./globals.css";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { initPostHog } from "./posthog/init-posthog";
import { initReloadOnPreloadError } from "./reload-on-preload-error";
import { initSentry } from "./sentry/init-sentry";
import { applyStoredTheme } from "./theme/apply-stored-theme";
import { isProspectInvitePath } from "./utils/is-prospect-invite-path";

initGoogleAnalytics();
initSentry();
initReloadOnPreloadError();

initPostHog();

document.documentElement.classList.add("antialiased");
applyStoredTheme();

const root = document.getElementById("root");

if (!root) throw new Error("Root element not found");

createRoot(root).render(
	<PostHogProvider client={posthog}>
		<App />
	</PostHogProvider>,
);

function initGoogleAnalytics() {
	const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
	if (
		isSensitiveUrl(window.location.href) ||
		isSensitiveUrl(document.referrer)
	) {
		Reflect.set(window, `ga-disable-${measurementId}`, true);
		return;
	}
	guardHistory("pushState");
	guardHistory("replaceState");
	gtag("config", measurementId, {
		environment: import.meta.env.VITE_APP_ENV,
	});
}

function guardHistory(method: "pushState" | "replaceState") {
	const original = history[method];
	history[method] = (data, unused, url) => {
		if (!url || !isSensitiveUrl(url)) original.call(history, data, unused, url);
		else if (method === "pushState") window.location.assign(url);
		else window.location.replace(url);
	};
}

function isSensitiveUrl(url: string | URL) {
	const { pathname, searchParams } = new URL(url, window.location.href);
	return isProspectInvitePath(pathname) || searchParams.has("__clerk_ticket");
}
